import { render, staticRenderFns } from "./model5Swiper.vue?vue&type=template&id=66b1750a&scoped=true"
import script from "./model5Swiper.vue?vue&type=script&lang=js"
export * from "./model5Swiper.vue?vue&type=script&lang=js"
import style0 from "./model5Swiper.vue?vue&type=style&index=0&id=66b1750a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b1750a",
  null
  
)

export default component.exports